import React from 'react';
import { HTMLTag } from '../../../../Utilities/HTMLTag';
import { TemplateItem } from '../model/TemplateItem';
import './DraggableBanner.css';
import { RelaxedDraggable } from './RelaxedDraggable';
interface Props {
    templateItem: TemplateItem
    scale: number
    disable: boolean
    printScale: number
}

interface States {
}
export default class DraggableBanner extends React.Component<Props, States> {
    render() {
        var id = HTMLTag.DRAGGABLE_COMPONENT_PREFIX + this.props.templateItem.id
        return (
            <RelaxedDraggable
                axis="both"
                handle=".handle"
                disabled={this.props.disable}
                position={{
                    x: 0,
                    y: 0
                }}
                grid={[1, 1]}
                scale={this.props.scale}
                defaultClassName=""
                onStart={() => { }}
                onDrag={() => { }}
                onStop={() => { }}
                onMouseDown={() => { }}
            >
                <div id={id} className="handle" style={{
                    // zIndex: 1,
                    position:'relative',
                    opacity: this.props.templateItem.style.opacity ? this.props.templateItem.style.opacity : 1 ,
                }}>
                    <img src={this.props.templateItem.image}
                        crossOrigin='anonymous'
                        style={{
                            width: '100%',
                            opacity: this.props.templateItem.style.opacity ? this.props.templateItem.style.opacity : 1,
                        }}
                        alt=''
                    >
                    </img>
                </div>
            </RelaxedDraggable>
        );
    }

}
